require('./transfersAgendaSummary.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKTable } = require('commonsComponents/OKTable');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ Components
const TransfersAgendaEmptyState = require('components/transfers/transfersAgenda/transfersAgendaEmptyState/transfersAgendaEmptyState');
const TransfersAgendaTableHeader = require('components/transfers/transfersAgenda/transfersAgendaTableHeader/transfersAgendaTableHeader');
const TransfersAgendaTableRow = require('components/transfers/transfersAgenda/transfersAgendaTableRow/transfersAgendaTableRow');
// @ actions
const beneficiariesActions = require('actions/beneficiaries');
// @ constants
const { BENEFICIARIES_LANDING_LIMIT } = require('constants/index');
const TRANSFERS_AGENDA_LINK = `/myprofile/transfers/agenda`;

class TransfersAgendaSummary extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.state = {
            expandedRow: null
        }
    }

    componentDidMount() {
        this.props.requestBeneficiaries();
    }

    buildBeneficiariesTableHead() {
        const { immScreen } = this.props;

        let tableHeadContent;

        if (!immScreen.get('isMobile')) {
            tableHeadContent = (
                <thead>
                    <TransfersAgendaTableHeader />
                </thead>
            );
        }

        return tableHeadContent;
    }

    buildBeneficiariesContent() {
        const { immBeneficiaries } = this.props;
        const immBeneficiariesByOder = immBeneficiaries.get('byOrder');
        const immBeneficiariesById = immBeneficiaries.get('byId');
        const size = immBeneficiariesByOder.size;
        const beneficiariesCount = Math.min(size, BENEFICIARIES_LANDING_LIMIT);
        const headerTitle = formatText('transfersLanding-transfersBeneficiaries');
        const tableBodyBlock = this.buildTableBody(
            immBeneficiariesByOder.take(beneficiariesCount),
            immBeneficiariesById
        );
        const addBeneficiaryButton = (
            <OKButton
                leftIcon="icon-agregar transfers-agenda__new-beneficiary-icon"
                modifier="ghost"
                to="/myprofile/transfers/agenda/addBeneficiary"
            >
                <FormattedText value="transfersAgenda-newBeneficiaryLabel" />
            </OKButton>
        );

        const tableHead = this.buildBeneficiariesTableHead();

        let nextPageButton;

        if (beneficiariesCount < size) {
            nextPageButton = (
                <footer className="text-right transfers-agenda-summary__more-button-container">
                    <OKLink modifier="complementary" to={TRANSFERS_AGENDA_LINK}>
                        <FormattedText value="transfersLanding-completeAgenda" />
                    </OKLink>
                </footer>
            );
        }

        return (
            <article className="transfers-agenda-summary">
                <header>
                    <div className="transfers-agenda-summary__title pull-left">
                        <OKBoxTitle value={headerTitle} to={TRANSFERS_AGENDA_LINK} />
                    </div>
                    <div className="pull-right">
                        {addBeneficiaryButton}
                    </div>
                </header>
                <section>
                    <OKTable>
                        {tableHead}
                        {tableBodyBlock}
                    </OKTable>
                </section>
                {nextPageButton}
            </article>
        );
    }

    buildEmptyState() {
        const title = formatText('transfersLanding-transfersBeneficiaries');

        return (
            <article className="transfers-agenda-summary">
                <header>
                    <div className="transfers-agenda-summary__title">
                        <OKBoxTitle value={title} />
                    </div>
                </header>
                <TransfersAgendaEmptyState />
            </article>
        );
    }

    buildErrorState() {
        const headerTitle = formatText('transfersLanding-transfersBeneficiaries');
        const errorMessage = formatText('transfersAgenda-errorFetchingBeneficiaries');
        return (
            <article className="transfers-agenda-summary">
                <header>
                    <OKBoxTitle value={headerTitle} to={TRANSFERS_AGENDA_LINK} />
                </header>
                <EmptyState primaryText={errorMessage} iconType="nointernet-banking"/>
            </article>
        );
    }

    buildLoadingState() {
        const headerTitle = formatText('transfersLanding-transfersBeneficiaries');

        return (
            <article className="transfers-agenda-summary">
                <header>
                    <OKBoxTitle value={headerTitle} to={TRANSFERS_AGENDA_LINK} />
                </header>
                <section>
                    <LoadingSection />
                </section>
            </article>
        );
    }

    buildTableBody(immBeneficiariesByOrder, immBeneficiariesById) {
        const { immScreen } = this.props;

        return immBeneficiariesByOrder.map((beneficiaryId, index) => {
            const isExpanded = this.state.expandedRow === index;

            const handleRowClick = () => {
                this.setState({
                    expandedRow: this.state.expandedRow === index ? null : index
                });
            };
            const immBeneficiary = immBeneficiariesById.get(beneficiaryId);
            return (
                <TransfersAgendaTableRow
                    key={index}
                    immBeneficiary={immBeneficiary}
                    immScreen={immScreen}
                    isExpanded={isExpanded}
                    onRowClick={handleRowClick}
                />
            );
        });
    }

    render() {
        const { immBeneficiaries } = this.props;
        let returnBlock;

        if (immBeneficiaries && immBeneficiaries.get('error')) {
            returnBlock = this.buildErrorState();
        } else if (immBeneficiaries && immBeneficiaries.get('isFetching')) {
            returnBlock = this.buildLoadingState();
        } else if (immBeneficiaries && immBeneficiaries.get('byOrder').size > 0) {
            returnBlock = this.buildBeneficiariesContent();
        } else {
            returnBlock = this.buildEmptyState();
        }

        return returnBlock;
    }
}

TransfersAgendaSummary.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestBeneficiaries: PropTypes.func.isRequired
};

module.exports.constructor = TransfersAgendaSummary;
module.exports.TransfersAgendaSummary = connect(
    state => ({
        immBeneficiaries: state.beneficiaries
    }),
    {
        requestBeneficiaries: beneficiariesActions.requestBeneficiaries
    }
)(TransfersAgendaSummary);
